"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TreeListStoreClass from "Stores/Table/TreeListStore";
import { tlSetStore, tlDestroyStore, tlUpdateUuid } from "Actions/TreeListActions";
import classNames from 'classnames';
import Uuid from "uuid";
import { createTreeListID } from "D5Utils/functions";

var styles = function styles(theme) {
  return {
    gridContainer: {
      height: 'calc(100% - 66px)'
    },
    fullHeight: {
      height: '100%'
    }
  };
};

var TreeList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TreeList, _React$Component);

  function TreeList(props) {
    var _this;

    _classCallCheck(this, TreeList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TreeList).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tlStore", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      UUID: Uuid()
    });

    return _this;
  }

  _createClass(TreeList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          formID = _this$props.formID,
          formUUID = _this$props.formUUID,
          parentFormID = _this$props.parentFormID,
          tableData = _this$props.tableData,
          owner = _this$props.owner;
      this.$treeview = $(this.el);
      this.tlStore = new TreeListStoreClass();
      setTimeout(function () {
        return tlSetStore({
          treeview: _this2.$treeview,
          formUUID: formUUID,
          UUID: _this2.state.UUID,
          formID: formID,
          store: _this2.tlStore,
          parentFormID: parentFormID,
          tableData: tableData,
          owner: owner
        });
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var _this$props2 = this.props,
          formUUID = _this$props2.formUUID,
          parentFormID = _this$props2.parentFormID; //обновляем formUUID в коммпоненте, кроме подченненыъ таблиц

      if (!parentFormID && nextProps.formUUID && formUUID !== nextProps.formUUID) {
        setTimeout(function () {
          tlUpdateUuid(formUUID, nextProps.formUUID);
        });
      }

      if (this.tlStore && this.tlStore.isNestedObject() && JSON.stringify(nextProps.tableData) !== JSON.stringify(this.props.tableData)) {
        this.tlStore.prepareNestedData(nextProps.tableData).then(function (data) {
          _this3.tlStore.instance().option('dataSource', data);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this4 = this;

      setTimeout(function () {
        return tlDestroyStore(_this4.state.UUID);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props3 = this.props,
          classes = _this$props3.classes,
          formID = _this$props3.formID,
          parentFormID = _this$props3.parentFormID;
      var id = createTreeListID(formID, parentFormID);
      return React.createElement("div", {
        className: classNames(classes.gridContainer)
      }, React.createElement("div", {
        className: classes.fullHeight,
        id: id,
        ref: function ref(r) {
          return _this5.el = r;
        }
      }));
    }
  }]);

  return TreeList;
}(React.Component);

_defineProperty(TreeList, "propTypes", {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  parentFormID: PropTypes.number,
  formTableMode: PropTypes.bool,
  owner: PropTypes.object
});

export default withStyles(styles, {
  withTheme: true
})(TreeList);